import React, { useEffect, useRef } from 'react';
import { animate, useInView } from 'framer-motion';

/* Number that counts up when it scrolls into view */
export default function Counter({ to, suffix = '', prefix = '', duration = 2, className }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.6 });
  useEffect(() => {
    if (!inView || !ref.current) return undefined;
    const c = animate(0, to, {
      duration, ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => { if (ref.current) ref.current.textContent = `${prefix}${Math.round(v)}${suffix}`; },
    });
    return () => c.stop();
  }, [inView, to, suffix, prefix, duration]);
  return <span ref={ref} className={className}>{prefix}0{suffix}</span>;
}
